<template>

  <div class="d-flex flex-column" style="min-width:95vw; max-width:95vw">
    <v-sheet class="ma-1">
      <div class="d-flex flex-row">
        <v-text-field v-model="searchBy" label="Search by Affinity Id | Company Name"
        prepend-inner-icon="mdi-magnify" variant="outlined" aria-label="Search by Affinity ID or Company Name"
        :error-messages="searchMessage" :aria-invalid="searchMessage.length > 0"
        aria-describedby="partner-lookup-status" @keydown.enter="getPartnerCompanyBy" />
        <v-btn class="ml-2" @click="getPartnerCompanyBy" @keydown.enter="getPartnerCompanyBy" icon="mdi-magnify" size="x-large" variant="text" aria-label="Search partner companies" />   
        <div style="width: 50%;"></div>
      </div>
      <div id="partner-lookup-status" class="text-body-2 ml-1" role="status" aria-live="polite">{{ searchMessage }}</div>
    </v-sheet>
    <v-sheet class="ma-1">
      <v-card 
      variant="outlined"
      title="Partner Company Lookup"
      flat>

      <v-data-table
      style="max-width: 92vw;"
        :items-per-page="-1" 
        :items-per-page-options="[5, 10, 25, 50, -1]"
        :headers="headers"
        :items="partnerCompany"  item-key="id"
        role="table"
        aria-label="Partner company lookup data">
          <template v-slot:item.obsfdc="{ item }">
              <v-icon :icon="item.obsfdc > 0 ? 'mdi-check' : 'mdi-close'" />
          </template>
          <template v-slot:item.participation="{ item }">
              <v-icon :icon="item.participation > 0 ? 'mdi-check' : 'mdi-close'" />
          </template>
      </v-data-table>
    </v-card>  
    </v-sheet>
  </div>

</template>

<script setup>
import { ref, onMounted } from 'vue'
import { usePartnerStore } from '@/stores/partner' 

const partnerStore = usePartnerStore()

const partnerCompany = ref([])
const searchBy = ref('')
const searchMessage = ref('')

// mirrors the minimum search length enforced by the api
const minimumSearchLength = 3

const headers = [
{ key: 'affinityID', title: 'Affinity Id'},
{ key: 'companyName', title: 'Company Name'},
{ key: 'country', title: "Country"},
{ key: 'region', title: 'Region'},
{ key: 'manager', title: 'Manager'},
{ key: 'noOfRegisteredUsers', title: 'Registered Users'},
{ key: 'acceptedTsAndCsDate', title: "Accepted T's & C's"},
{ key: 'obsfdc', title: 'OBSFDC'},
{ key: 'participation', title: 'Participation'},
{ key: 'participationReason', title: 'Participation Reason'}
]

onMounted(() => {})

const getPartnerCompanyBy = () => {  
  const searchValue = searchBy.value.trim()
  const isAffinityId = /^\d+$/.test(searchValue)

  if (searchValue === '' || (!isAffinityId && searchValue.length < minimumSearchLength)) {
    searchMessage.value = `Enter an Affinity Id or at least ${minimumSearchLength} characters of a company name`
    partnerCompany.value = []
    return
  }

  searchMessage.value = ''

  partnerStore.getPartnerCompanyBy(searchValue).then(result => {
    if (result.hasData) {
      partnerCompany.value = result.partnerCompany
    }
    else {
      partnerCompany.value = []
      searchMessage.value = result.messages && result.messages.length > 0 ? result.messages[0] : 'No entries found'
    }
  })
} 

</script>

<style scoped>
.modal-mask {
position: fixed;
z-index: 500;
top: 0;
left: 0;
width: 100%;
height: 100%;
background-color: rgba(0, 0, 0, 0.5);
display: table;
transition: opacity 0.3s ease;
}

.modal-wrapper {
display: table-cell;
vertical-align: middle;
}

.modal-container {
width: 500px;
margin: 5px auto;
padding: 5px 30px;
background-color: #fff;
border-radius: 10px;
box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
transition: all 0.3s ease;
}

.modal-body {
margin: 20px 0;
}

.modal-save-button {
margin: 0px 10px;
}

.modal-cancel-button {
margin: 0px 10px;
}

.modal-enter-from {
opacity: 0;
}

.modal-leave-to {
opacity: 0;
}

.modal-enter-from .modal-container,
.modal-leave-to .modal-container {
-webkit-transform: scale(1.1);
transform: scale(1.1);
}

</style>